import React from "react";
import { Stepper, Step, StepButton, Button, Snackbar } from "@mui/material";
import Member from "../../components/administration/AddBooking/Member";
import BookingMembers from "../../models/BookingMembers";
import BookingTeams from "../../models/BookingTeams";
import Bookings from "../../models/Bookings";
import RestUtilities from "../../services/RestUtilities";
import MemberGenderTypes from "../../models/MemberGenderTypes";
import EventAdditionalPriceDefinitions from "../../models/EventAdditionalPriceDefinitions";
import EventPriceDefinitions from "../../models/EventPriceDefinitions";
import BookingMemberToEventPriceDefinition from "../../models/BookingMemberToEventPriceDefinition";
import BookingMemberToEventAdditionalPriceDefinition from "../../models/BookingMemberToEventAdditionalPriceDefinition";
import Payment from "../../components/administration/AddBooking/Payment";
import PaymentTypes from "../../models/PaymentTypes";
const PaypalComponent = require("../../components/User/Paypal").default;
import PaymentTransactions from "../../models/PaymentTransactions";
import { RoutePaths } from "../../components/Routes";
import Loader from "../../components/Loader";
import { BookingMemberRequiredFieldsValid } from "../administration/AddBooking";
import AuthStore from "../../stores/Auth";
import { UserRoles } from "../../models/UserRoles";
import Auth from "../../services/Auth";
import Events from "../../models/Events";
import { EventOptionAvailabilityTypesEnum } from "../../models/EventOptionAvailabilityTypes";
import { GrowMessage } from "../../components/GrowMessage";
import { withRouter } from "../../components/Shared/withNavigate";

const Paypal: any = PaypalComponent;

class AddBooking extends React.Component<any, any> {
  public static FirstStep: string = "Zahlungsart";
  public static SecondStep: string = "Teilnehmer";
  public static ThirdStep: string = "Paypal";

  public static SubmitMode: string = "Submit";
  public static EditMode: string = "Edit";

  eventId: number = 0;

  transaction = new PaymentTransactions();

  constructor(props: any) {
    super(props);

    const params = new URLSearchParams(this.props.router.location.search);
    const eventId = params.get("eventId");

    this.eventId = parseInt(eventId);
  }

  state = {
    event: new Events(),
    activeStep: 0,
    showAddBookingMemberModal: false,
    showAddTeamBookingMemberModal: false,
    showAddTeamModal: false,
    bookingMember: new BookingMembers(),
    bookingMembersList: [] as BookingMembers[],
    bookingTeams: [] as BookingTeams[],
    booking: new Bookings(),
    genderTypes: [] as MemberGenderTypes[],
    options: [] as EventAdditionalPriceDefinitions[],
    priceDefinitions: [] as EventPriceDefinitions[],
    selectedOptions: [] as EventAdditionalPriceDefinitions[],
    paymentTypes: [] as PaymentTypes[],
    newTeam: new BookingTeams(),
    modeTeam: "Submit",
    modeMember: "Submit",
    showError: false,
    errorMessage: "",
    loading: false,
    bookingMemberRequiredFieldsValid: new BookingMemberRequiredFieldsValid(),
    disableSaveButton: false,
    IsSingleAvailable: false,
    IsTeamPlayerAvailable: false,
    IsTeamAvailable: false,
  };

  getSteps = (): string[] => {
    let steps = [AddBooking.FirstStep, AddBooking.SecondStep];

    //if paymentType is PayPal
    if (this.state.booking.paymentTypeId === 2)
      steps.push(AddBooking.ThirdStep);

    return steps;
  };

  getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <Payment
            personalNr={AuthStore.getPersonalNr()}
            fetchPaymentTypes={this.fetchPaymentTypes}
            paymentTypes={this.state.paymentTypes}
            paymentTypeId={this.state.booking.paymentTypeId}
            change={this.changePaymentType}
          ></Payment>
        );
      case 1:
        return (
          <Member
            teamBookingMemberModal={this.state.showAddTeamBookingMemberModal}
            bookingMemberModal={this.state.showAddBookingMemberModal}
            teamModal={this.state.showAddTeamModal}
            hideModal={this.hideModal}
            showAddBookingMemberModal={this.showAddBookingMemberModal}
            showAddTeamBookingMemberModal={this.showAddTeamBookingMemberModal}
            showAddTeamModal={this.showAddTeamModal}
            fetchGenderTypes={this.fetchMemberGenderTypes}
            genderTypes={this.state.genderTypes}
            fetchOptions={this.fetchEventAdditionalPriceDefinitions}
            options={this.state.options}
            fetchPrices={this.fetchEventPriceDefinitions}
            prices={this.state.priceDefinitions}
            changeMember={this.handleChangeBookingMember}
            bookingMember={this.state.bookingMember}
            addOption={this.handleAddOptionToMember}
            submit={this.submitBookingMember}
            bookingMembersList={this.state.bookingMembersList}
            fetchBookingMembersList={this.fetchBookingMembers}
            selectedOptions={this.state.selectedOptions}
            delete={this.deleteBookingMember}
            changeMode={this.handleChangeMode}
            changeBookingMember={this.handleChangeCurrentBookingMember}
            fetchTeams={this.fetchBookingTeams}
            bookingTeams={this.state.bookingTeams}
            changeNewTeam={this.handleChangeTeam}
            newTeam={this.state.newTeam}
            submitNewTeam={this.submitNewTeam}
            booking={this.state.booking}
            changeBooking={this.handleChangeBooking}
            changeTeamMode={this.handleChangeTeamMode}
            changeCurrentTeam={this.handleChangeCurrentTeam}
            validFields={this.state.bookingMemberRequiredFieldsValid}
            eventObject={this.state.event}
            deleteTeam={this.deleteTeam}
            disableSaveButton={this.state.disableSaveButton}
            switchSaveButton={this.switchSaveButton}
            resetSelectedOptions={this.resetSelectedOptions}
            IsSingleAvailable={this.state.IsSingleAvailable}
            IsTeamPlayerAvailable={this.state.IsTeamPlayerAvailable}
            IsTeamAvailable={this.state.IsTeamAvailable}
          ></Member>
        );
      case 2:
        return (
          <Paypal
            transaction={this.transaction}
            booking={this.state.booking}
            submit={this.submitTransaction}
            event={this.state.event}
          ></Paypal>
        );
      default:
        return <></>;
    }
  };

  handleNext = (): void => {
    const { activeStep } = this.state;
    const stepsCount = this.getSteps().length;

    if (activeStep === 1 && !this.state.booking.isValid) return;

    if (stepsCount - activeStep - 1 === 0) {
      if (!this.state.booking.isValid) {
        this.showError({ error_content: "Die Anmeldung ist nicht gültig" });
        return;
      }

      this.editBooking(true).then(() => {
        this.props.router.navigate(`${RoutePaths.CurrentEvents}`);
      });
    }

    if (activeStep === 0) {
      if (this.state.booking.id > 0) {
        this.editBooking()
          .then(() => {
            this.setState({ activeStep: activeStep + 1 });
          })
          .catch((err) => {
            console.error("Caught:", err);
          });
      } else {
        this.submitBooking()
          .then((data: any) => {
            this.setState({ activeStep: activeStep + 1 });
          })
          .catch((err) => {
            console.error("Caught:", err);
          });
      }
    } else {
      this.setState({ activeStep: activeStep + 1 });
    }
  };

  handleBack = (): void => {
    const { activeStep } = this.state;
    this.setState({ activeStep: activeStep - 1 });
  };

  switchSaveButton = (disable: boolean) => {
    if (disable !== this.state.disableSaveButton)
      this.setState((state: any) => ({
        disableSaveButton: disable,
      }));
  };

  hideModal = (): void => {
    const requiredFields = {
      ...Object.keys(this.state.bookingMemberRequiredFieldsValid).reduce(
        (reduced, key) => ({ ...reduced, [key]: true }),
        {}
      ),
    };

    this.setState({
      showAddBookingMemberModal: false,
      showAddTeamBookingMemberModal: false,
      showAddTeamModal: false,
      bookingMember: new BookingMembers(),
      newTeam: new BookingTeams(),
      bookingMemberRequiredFieldsValid: requiredFields,
    });
  };

  showAddBookingMemberModal = (member: BookingMembers): void => {
    this.setState({ showAddBookingMemberModal: true }, () =>
      this.handleChangeCurrentBookingMember(member)
    );
  };

  showAddTeamBookingMemberModal = (member: BookingMembers): void => {
    if (this.state.bookingTeams.length === 0) {
      this.showAddTeamModal();
      return;
    }

    this.setState({ showAddTeamBookingMemberModal: true }, () =>
      this.handleChangeCurrentBookingMember(member)
    );
  };

  showAddTeamModal = (): void => {
    this.setState({ showAddTeamModal: true });
  };

  handleChangeBookingMember = (event: any): void => {
    const targetValue = event.target.value;
    const targetName = event.target.name;
    this.setState((prevState: any, props: any) => {
      const newModel = { ...prevState.bookingMember };
      newModel[targetName] = targetValue;
      this.validateBookingMember(newModel);
      return { bookingMember: newModel };
    });
  };

  handleChangeMode = (mode: string): void => {
    this.setState({ modeMember: mode });
  };

  handleAddOptionToMember = (event: any): void => {
    const optionId = event.target.value;
    const optionTypeName = event.target.name;
    const { selectedOptions } = this.state;

    if (optionId === "") {
      let isPriceOfTypePresent =
        this.state.selectedOptions.filter(
          (x) => x.eventAdditionalPriceTypeName === optionTypeName
        ).length > 0;

      if (isPriceOfTypePresent) {
        const index = selectedOptions.findIndex(
          (x) => x.eventAdditionalPriceTypeName === optionTypeName
        );
        selectedOptions.splice(index, 1);
      }
      this.setState({ selectedOptions: selectedOptions });
      return;
    }

    const optionToAdd = this.state.options.filter((x) => x.id === optionId)[0];
    const optionType = optionToAdd.eventAdditionalPriceTypeId;

    let isPriceOfTypePresent =
      selectedOptions.filter((x) => x.eventAdditionalPriceTypeId === optionType)
        .length > 0;

    if (isPriceOfTypePresent) {
      const index = selectedOptions.findIndex(
        (x) => x.eventAdditionalPriceTypeId === optionType
      );
      selectedOptions.splice(index, 1);
    }
    selectedOptions.push(optionToAdd);

    this.setState({ selectedOptions: selectedOptions });
  };

  handleChangeCurrentBookingMember = (member: BookingMembers) => {
    const { options } = this.state;
    const selectedOptions =
      member.tblBookingMemberToEventAdditionalPriceDefinition.map((x) => {
        return options.filter(
          (y) => y.id === x.eventAdditionalPriceDefinitionId
        )[0];
      });
    const isTeamMember =
      this.state.showAddTeamBookingMemberModal === true
        ? EventOptionAvailabilityTypesEnum.Team
        : EventOptionAvailabilityTypesEnum.Einzel;
    this.fetchEventPriceDefinitions(
      member.memberAgeGroupId,
      member.memberGroupTypeId,
      member.eventOptionId,
      isTeamMember
    ).then(() => {
      this.setState({
        bookingMember: member,
        selectedOptions: selectedOptions,
      });
    });
  };

  handleChangeBooking = (event: any): void => {
    const newBooking = { ...this.state.booking };
    const fieldName = event.target.name;

    newBooking[fieldName] = event.target.value;

    this.setState({ booking: newBooking });
  };

  handleChangeCurrentTeam = (team: BookingTeams): void => {
    this.setState({ newTeam: team });
  };

  handleChangeTeam = (event: any): void => {
    const newTeam = { ...this.state.newTeam };
    const fieldName = event.target.name;

    newTeam[fieldName] = event.target.value;

    this.setState({ newTeam: newTeam });
  };

  handleChangeTeamMode = (mode: string): void => {
    this.setState({ modeTeam: mode });
  };

  changePaymentType = (event: any): void => {
    const newBooking = { ...this.state.booking };

    const typeId = event.target.value;

    newBooking.paymentTypeId = parseInt(typeId);

    this.setState({ booking: newBooking });
  };

  checkIsSingleAvailable = () => {
    RestUtilities.get<any>(
      `/api/BookingMembers/IsSingleAvailable?eventId=${this.eventId}`
    )
      .then((resp) => {
        this.setState({ IsSingleAvailable: true });
      })
      .catch((err) => {
        this.setState({ IsSingleAvailable: false });
      });
  };

  checkIsTeamAvailable = () => {
    RestUtilities.get<any>(
      `/api/BookingMembers/IsTeamAvailable?eventId=${this.eventId}`
    )
      .then((resp) => {
        this.setState({ IsTeamAvailable: true });
      })
      .catch((err) => {
        this.setState({ IsTeamAvailable: false });
      });
  };


  checkIsTeamPlayerAvailable = () => {
    RestUtilities.get<any>(
      `/api/BookingMembers/IsTeamPlayerAvailable?eventId=${this.eventId}`
    )
      .then((resp) => {
        this.setState({ IsTeamPlayerAvailable: true });
      })
      .catch((err) => {
        this.setState({ IsTeamPlayerAvailable: false });
      });
  };

  editBooking = (isFinished: boolean = false): Promise<any> => {
    const booking = { ...this.state.booking };
    booking.eventId = this.eventId;

    return RestUtilities.put<Bookings>(
      `/api/Bookings/Edit?isFinished=${isFinished}`,
      booking
    )
      .then((resp) => {
        this.setState({ booking: resp.content });
      })
      .catch((resp) => {
        this.showError(resp);
        throw resp.error_content;
      });
  };

  validateBookingMember = (bookingMember: BookingMembers): boolean => {
    let requiredFields: any = {};
    if (this.state.showAddTeamBookingMemberModal) {
      requiredFields = {
        ...this.state.bookingMemberRequiredFieldsValid,
        teamId: true,
      };
    } else {
      const { teamId, ...rest } = this.state.bookingMemberRequiredFieldsValid;
      requiredFields = rest;
    }
    let valid: boolean = true;

    Object.keys(requiredFields).map((x) => {
      if (
        bookingMember[x] === null ||
        bookingMember[x] === undefined ||
        bookingMember[x] === ""
      ) {
        valid = false;
        requiredFields[x] = false;
      } else {
        requiredFields[x] = true;
      }
    });

    let optionTypes = (
      this.state.options as EventAdditionalPriceDefinitions[]
    ).map((x) => {
      return x.eventAdditionalPriceTypeId;
    });
    optionTypes = [...new Set(optionTypes)];

    valid =
      valid &&
      optionTypes.every((x) => {
        const isSelected =
          this.state.selectedOptions.filter(
            (y) => y.eventAdditionalPriceTypeId === x
          ).length > 0;
        return isSelected;
      });

    this.setState({ bookingMemberRequiredFieldsValid: requiredFields });
    return valid;
  };

  fetchMemberGenderTypes = (): void => {
    RestUtilities.get<MemberGenderTypes[]>("/api/MemberGenderTypes")
      .then((resp) => {
        this.setState({ genderTypes: resp.content });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchEventAdditionalPriceDefinitions = (
    ageGroupId: number = null,
    memberGroupId: number = null
  ): void => {
    let url = `/api/EventAdditionalPriceDefinitions?eventId=${this.eventId}`;

    if (ageGroupId !== null) {
      url += `&ageGroupId=${ageGroupId}`;
    }

    if (memberGroupId !== null) {
      url += `&memberGroupId=${memberGroupId}`;
    }

    RestUtilities.get<EventAdditionalPriceDefinitions[]>(url)
      .then((resp) => {
        this.setState({ options: resp.content });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchEventPriceDefinitions = (
    ageGroupId: number = null,
    memberGroupId: number = null,
    eventOptionId: number = null,
    availabilityTypeId: number = null
  ): Promise<void> => {
    let url = `/api/EventPriceDefinitions?eventId=${this.eventId}`;

    if (ageGroupId !== null) {
      url += `&ageGroupId=${ageGroupId}`;
    }

    if (memberGroupId !== null) {
      url += `&memberGroupId=${memberGroupId}`;
    }

    if (eventOptionId !== null) {
      url += `&eventOptionId=${eventOptionId}`;
    }

    if (availabilityTypeId !== null)
      url += `&availabilityTypeId=${availabilityTypeId}`;

    return RestUtilities.get<EventPriceDefinitions[]>(url)
      .then((resp) => {
        this.setState({ priceDefinitions: resp.content });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchBookingMembers = (): Promise<void> => {
    const bookingId = this.state.booking.id;

    this.setState({ loading: true });
    return RestUtilities.get<BookingMembers[]>(
      `/api/BookingMembers?bookingId=${bookingId}`
    )
      .then((resp) => {
        this.setState({ bookingMembersList: resp.content, loading: false });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchBookingTeams = (): Promise<void> => {
    const bookingId = this.state.booking.id;

    this.setState({ loading: true });
    return RestUtilities.get<BookingTeams[]>(
      `/api/BookingTeams?bookingid=${bookingId}`
    )
      .then((resp) => {
        this.setState({ bookingTeams: resp.content, loading: false });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchBooking = (bookingId: number): void => {
    RestUtilities.get<Bookings>(`/api/Bookings?bookingId=${bookingId}`)
      .then((resp) => {
        this.setState({ booking: resp.content });
        this.checkIsSingleAvailable();
        this.checkIsTeamAvailable();
        this.checkIsTeamPlayerAvailable();
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchPaymentTypes = (personalNr: string = ""): void => {
    let url = `/api/PaymentTypes?personalNr=${personalNr}`;
    if (!personalNr || personalNr === "") url = "/api/PaymentTypes";
    RestUtilities.get<PaymentTypes[]>(url)
      .then((resp) => {
        let response = resp.content as PaymentTypes[];

        if (
          AuthStore.getRole() === UserRoles[UserRoles.Benutzer] ||
          AuthStore.getRole() === UserRoles[UserRoles.Veranstalter]
        ) {
          if (AuthStore.getIsLonhabzugberechtigt() !== "true") {
            let index = response.findIndex((x) => x.id === 1);
            response.splice(index, 1);
          }

          let barBLIndex = response.findIndex((x) => x.id === 4);
          let barBGIndex = response.findIndex((x) => x.id === 3);
          response.splice(barBLIndex, 1);
          response.splice(barBGIndex, 1);
        }
        this.setState({ paymentTypes: response });
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  fetchEvent = () => {
    RestUtilities.get<Events>(`/api/Events?eventId=${this.eventId}`).then(
      (resp) => {
        const requiredFields = {
          ...this.state.bookingMemberRequiredFieldsValid,
        };
        if (resp.content.memberGenderTypeRequired) {
          requiredFields["gender"] = true;
        }
        if (resp.content.memberBirthDateRequired)
          requiredFields["birthday"] = true;

        this.setState({
          event: resp.content,
          bookingMemberRequiredFieldsValid: requiredFields,
        });

      }
    );
  };

  submitBookingMember = (): void => {
    const bookingMember = { ...this.state.bookingMember };
    bookingMember.bookingId = this.state.booking.id;
    const event = { ...this.state.event };

    bookingMember.tblBookingMemberToEventPriceDefinition =
      this.state.priceDefinitions.map((x) => {
        let memberToPrice = new BookingMemberToEventPriceDefinition();
        memberToPrice.eventPriceDefinitionId = x.id;
        return memberToPrice;
      });

    bookingMember.tblBookingMemberToEventAdditionalPriceDefinition =
      this.state.selectedOptions.map((x) => {
        let memberToAdditionalPrice =
          new BookingMemberToEventAdditionalPriceDefinition();
        memberToAdditionalPrice.eventAdditionalPriceDefinitionId = x.id;
        return memberToAdditionalPrice;
      });

    if (
      typeof bookingMember.teamId == "undefined" ||
      event.singleTeamPrice === null ||
      event.singleTeamPrice === 0
    )
      bookingMember.overallPrice += this.state.priceDefinitions.reduce(
        (sum, x) => sum + x.priceValue,
        0
      );

    bookingMember.overallPrice += this.state.selectedOptions.reduce(
      (sum, x) => sum + x.priceValue,
      0
    );

    if (!this.validateBookingMember(bookingMember)) return;

    this.setState({ loading: true });

    const birthday = bookingMember.birthday;
    if (
      birthday !== undefined &&
      birthday !== null &&
      typeof birthday != "string"
    )
      bookingMember.birthday.setHours(22); //so that it does not go to previous day after subtracting time difference
    if (this.state.modeMember === AddBooking.SubmitMode) {
      RestUtilities.post<BookingMembers>(
        "/api/BookingMembers/Submit",
        bookingMember
      )
        .then((resp) => {
          this.fetchBookingMembers().then(() => {
            const isTeamValid =
              this.state.event.maxTeamSize ===
              this.state.bookingMembersList.filter(
                (x) => x.teamId === resp.content.teamId
              ).length;
            if (resp.content.teamId !== null && !isTeamValid) {
            } else {
              this.hideModal();
            }
          });

          this.fetchBooking(this.state.booking.id);
          this.fetchBookingTeams();
          this.handleChangeCurrentBookingMember(new BookingMembers());

          const requiredFields = {
            ...Object.keys(this.state.bookingMemberRequiredFieldsValid).reduce(
              (reduced, key) => ({ ...reduced, [key]: true }),
              {}
            ),
          };

          this.setState({
            bookingMemberRequiredFieldsValid: requiredFields,
            selectedOptions: [],
          });
        })
        .catch((resp) => {
          this.showError(resp);
        });
    } else if (this.state.modeMember === AddBooking.EditMode) {
      RestUtilities.put<BookingMembers>(
        "/api/BookingMembers/Edit",
        bookingMember
      )
        .then((resp) => {
          this.fetchBookingMembers();
          this.fetchBooking(this.state.booking.id);
          this.handleChangeCurrentBookingMember(new BookingMembers());
          this.fetchBookingTeams();
          this.hideModal();
          this.setState({ loading: false });
        })
        .catch((resp) => {
          this.showError(resp);
        });
    }
  };

  submitNewTeam = (): void => {
    const newTeam = { ...this.state.newTeam };
    newTeam.bookingId = this.state.booking.id;

    if (this.state.modeTeam === "Submit") {
      RestUtilities.post<BookingTeams>("/api/BookingTeams/Submit", newTeam)
        .then((resp) => {
          this.fetchBooking(this.state.booking.id);
          this.fetchBookingTeams().then(() => {
            this.setState(
              {
                showAddTeamModal: false,
              },
              () => this.showAddTeamBookingMemberModal(new BookingMembers())
            );
          });
        })
        .catch((resp) => {
          this.showError(resp);
        });
    } else if (this.state.modeTeam === "Edit") {
      RestUtilities.put<BookingTeams>("/api/BookingTeams/Edit", newTeam)
        .then((resp) => {
          this.fetchBookingTeams();
          this.hideModal();
        })
        .catch((resp) => {
          this.showError(resp);
        });
    }
  };

  submitBooking = (): Promise<any> => {
    const booking = { ...this.state.booking };
    booking.eventId = this.eventId;

    if (this.state.booking.paymentTypeId == undefined) {
      this.showError({ error_content: "Bitte wählen Sie eine Zahlungsart!" });
      return Promise.reject(undefined);
    }

    this.setState({ loading: true });
    return RestUtilities.post<Bookings>("/api/Bookings/Submit", booking)
      .then((resp) => {
        this.setState({ booking: resp.content, loading: false });
      })
      .catch((resp) => {
        this.showError(resp);
        throw resp;
      });
  };

  submitTransaction = (): void => {
    const transaction = { ...this.transaction };
    transaction.bookingId = this.state.booking.id;
    transaction.transactionAmount = this.state.booking.bookingTotal;

    this.setState({ loading: true });

    RestUtilities.post<PaymentTransactions>(
      "/api/Payment/SavePaymentTransaction",
      transaction
    )
      .then((resp) => {
        this.setState({ loading: false });

        if (transaction.transactionStatus === "Success") {
          this.fetchBooking(this.state.booking.id);
          setTimeout(() => this.handleNext(), 1500);
        }
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  deleteBookingMember = (id: number): void => {
    RestUtilities.delete(`/api/BookingMembers/Delete?id=${id}`)
      .then((resp) => {
        this.fetchBookingMembers();
        this.fetchBooking(this.state.booking.id);
        this.fetchBookingTeams();
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  showError = (resp: any): void => {
    if (typeof resp.error_content != "undefined" && resp.error_content) {
      this.setState({
        showError: true,
        errorMessage: resp.error_content,
        loading: false,
      });
    }
  };

  deleteTeam = (id: number) => {
    const url = `/api/BookingTeams/Delete?id=${id}`;

    RestUtilities.delete(url)
      .then((resp) => {
        this.fetchBookingTeams();
        this.fetchBooking(this.state.booking.id);
      })
      .catch((resp) => {
        this.showError(resp);
      });
  };

  resetSelectedOptions = () => {
    this.setState({ selectedOptions: [] });
  };

  handleSnackbarClose = (event: any, reason: string) => {
    if (reason === "clickaway") return;

    this.setState({ showError: false });
  };

  componentDidMount() {
    this.fetchPaymentTypes(AuthStore.getPersonalNr());
    this.fetchEvent();
    this.checkIsSingleAvailable();
    this.checkIsTeamAvailable();
    this.checkIsTeamPlayerAvailable();
  }

  public render() {
    const { activeStep } = this.state;
    const steps: any[] = this.getSteps();

    return (
      <>
        <Stepper alternativeLabel nonLinear activeStep={activeStep}>
          {steps.map((label, index) => {
            const props = {};
            const buttonProps = {};
            return (
              <Step key={label} {...props}>
                <StepButton
                  // onClick={() => this.handleStep(index)}
                  // completed={this.isStepComplete(index)}
                  {...buttonProps}
                >
                  {label}
                </StepButton>
              </Step>
            );
          })}
        </Stepper>
        <div className="row mt-4 mb-3 saveButton">
          <div>
            {activeStep !== 0 && activeStep <= steps.length - 1 && (
              <Button
                onClick={this.handleBack}
                variant="contained"
                className="mr-2 btnBlue"
              >
                Zurück
              </Button>
            )}
            {activeStep <= steps.length - 1 &&
              activeStep !== 2 && ( //if we have activeStep === 2, then we are on PayPal page and can close only after paying
                <Button
                  className="btnBlue"
                  variant="contained"
                  color="primary"
                  onClick={this.handleNext}
                >
                  {activeStep === steps.length - 1
                    ? "Speichern & Abschließen"
                    : "Speichern & Weiter"}
                </Button>
              )}
          </div>
        </div>
        <div>{this.getStepContent(activeStep)}</div>
        <GrowMessage
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          message={this.state.errorMessage}
          visible={this.state.showError}
          autoHideDuration={6000}
          onClose={this.handleSnackbarClose}
        ></GrowMessage>
        {this.state.loading && <Loader />}
      </>
    );
  }
}

export default withRouter(AddBooking);
